import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './bootstrap.min.css';
import { Provider } from 'react-redux';
import { store } from './store';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from 'react-helmet-async';
import { ColorModeProvider } from './theme/ThemeContext';
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';
import { isNativeApp } from './utils/platform';

// Initialize native Google Sign-In only inside the Capacitor shell. The web
// build uses @react-oauth/google instead. serverClientId must be the WEB
// OAuth client id so the issued id_token audience matches the backend.
if (isNativeApp()) {
  GoogleAuth.initialize({
    clientId: process.env.REACT_APP_GOOGLE_ID,
    scopes: ['profile', 'email'],
    grantOfflineAccess: true,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <ColorModeProvider>
          <App />
        </ColorModeProvider>
      </HelmetProvider>
    </Provider>
  </React.StrictMode>,
);

reportWebVitals();
